module.exports = __webpack_public_path__ + "static/media/amsh-slack.6ea5a691.svg";